import { useEffect } from 'react';
import { useRouter } from 'next/compat/router';
import styled from 'styled-components';

import { FACILITY_PATHS } from '@pass-frontend/common/constants/paths';
import { useIntl } from '@pass-frontend/common/i18n';
import {
  MemberCheckModuleLoader,
  useCurrenEligibilityCheck,
} from '@pass-frontend/features/facility-checkin/data-bridge';
import { RdsButton } from '@pass-frontend/rally-energon-react';
import { RESPONSIVE_QUERY } from '@pass-frontend/utility/style-helpers';

import { ErrorInfo } from '../error-info';
import { FacilityHeader } from '../facility-header/facility-header';
import { MemberDetails } from '../member-details/member-details';
import { SuccessInfo } from '../success-info';
import { isGovernmentDependentMemberCheck } from '../utility';

const LocationAccessWrapper = styled.div`
  min-height: calc(100vh - 144px);
`;

const WidthConstrainer = styled.div`
  margin: 0 auto;
  max-width: 1272px;

  ${RESPONSIVE_QUERY.large} {
    width: 90%;
  }
`;

const BoxContent = styled.div`
  max-width: 840px;

  .error-info-image {
    width: 30px;
  }
`;

export function LocationAccess() {
  const { t } = useIntl();
  const router = useRouter();
  const { memberDetails } = useCurrenEligibilityCheck();
  const hasAccess = router?.query?.hasAccess as string | undefined;
  const isCommercialMember = memberDetails?.sector === 'Commercial';
  const isGovernmentDependentMember =
    isGovernmentDependentMemberCheck(memberDetails);

  useEffect(() => {
    if (!memberDetails || !hasAccess) {
      router?.push(FACILITY_PATHS.DASHBOARD);
    }
  }, [memberDetails]);

  const handleNewSearchClick = () => {
    router?.push(FACILITY_PATHS.DASHBOARD);
  };

  const info = (
    <div className="has-rds-mb-8">
      {hasAccess === 'true' ? (
        <SuccessInfo
          isGovernmentDependent={isGovernmentDependentMember}
          message={
            isGovernmentDependentMember
              ? t('facilityWeb.locationAccess.govDepAccessSuccess')
              : t('facilityWeb.locationAccess.accessSuccess')
          }
        />
      ) : (
        <ErrorInfo
          message={
            isCommercialMember
              ? t('facilityWeb.locationAccess.commAccessError')
              : t('facilityWeb.locationAccess.govtAccessError')
          }
        />
      )}
    </div>
  );

  return (
    <>
      <FacilityHeader />
      <LocationAccessWrapper className="has-rds-bg-grey-lightest has-rds-pb-64">
        <WidthConstrainer className="has-rds-pv-40">
          <BoxContent>
            <MemberCheckModuleLoader>
              <MemberDetails
                title={t('facilityWeb.locationAccess.title')}
                memberDetails={memberDetails}
                info={info}
                hasAccess={hasAccess === 'true'}
                fromLocationAccess={true}
              />
              <RdsButton
                className="has-rds-mt-24"
                onClick={handleNewSearchClick}
              >
                {t('facilityWeb.newMemberSearch')}
              </RdsButton>
            </MemberCheckModuleLoader>
          </BoxContent>
        </WidthConstrainer>
      </LocationAccessWrapper>
    </>
  );
}
